import React from "react"
import Hero from "../sections/Hero"
import FeaturedProjects from "../sections/FeaturedProjects"
import StatsSection from "../sections/StatsSection"
import ServicesGrid from "../sections/ServicesGrid"
import InteriorShowcase from "../sections/InteriorShowcase"
import Visualization3D from "../sections/Visualization3D"
import JournalSection from "../sections/JournalSection"
import CTASection from "../sections/CTASection"

export default function Home() {
  return (
    <main>
      <Hero />
      <FeaturedProjects />
      <StatsSection />
      <ServicesGrid />
      <InteriorShowcase />
      <Visualization3D />
      <JournalSection />
      <CTASection />
    </main>
  )
}
